import React, { useMemo, useState } from 'react';
import * as Styles from './Styles';
import ConsentRow from './ConsentRow';
import SvgBulb from '../../../../../others/svg_dist/Bulb';
import Selectable from './Selectable';
import SvgArrowDown2 from '../../../../../others/svg_dist/ArrowDown2';
import * as ExtendedContent from './extendedContent';
import PaginatedDescription from '../../../../../components/paginatedDescription/PaginatedDescription';
import { IRisk } from '../../../../../models/Dictionaries';
import * as FormManager from '../../../../../reducers/ui/form';

export const NNWHeading = () => (
	<>
		<p>ubezpieczenie Następstw Nieszczęśliwych Wypadków</p>
		<p>
			wybierz wariant ubezpieczenia{' '}
			<span>(zaznacz odpowiedni kafelek)</span>
		</p>
	</>
);

export const NNWTopContent = (props: {
	selectedColumn: string;
	risks: IRisk[];
	selectedRisksIds: number[];
}) => {
	const column1Active = useMemo(
		() => props.selectedColumn === '1',
		[props.selectedColumn]
	);
	const column2Active = useMemo(
		() => props.selectedColumn === '2',
		[props.selectedColumn]
	);
	const column3Active = useMemo(
		() => props.selectedColumn === '3',
		[props.selectedColumn]
	);
	const column4Active = useMemo(
		() => props.selectedColumn === '4',
		[props.selectedColumn]
	);

	const columnActiveArray = [
		column1Active,
		column2Active,
		column3Active,
		column4Active,
	];

	const risksFirstHalf = useMemo(
		() => props.risks.filter((_el, idx) => idx < 4),
		[props.risks]
	);
	const risksSecondHalf = useMemo(
		() => props.risks.filter((_el, idx) => idx >= 4),
		[props.risks]
	);

	const [assistanceExpanded, setAssistanceExpanded] = useState(false);

	return (
		<Styles.NNWContentContainer>
			<Styles.NNWContentHeadingContainer>
				<p>
					<strong>klauzula alkoholowa</strong> w każdym wariancie!
				</p>
				<Styles.NNWContentHeadingIcon>
					<SvgBulb />
				</Styles.NNWContentHeadingIcon>
			</Styles.NNWContentHeadingContainer>
			<div
				style={{ width: '100%', marginTop: '15px', overflowX: 'auto' }}
			>
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableBlankCell />
					<Styles.NNWContentTableCell
						data-column-active={column1Active}
					>
						wariant I
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column2Active}
					>
						wariant II
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column3Active}
					>
						wariant III
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column4Active}
					>
						wariant IV
					</Styles.NNWContentTableCell>
				</Styles.NNWContentTableRow>
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableNameCell>
						śmierć w wyniku nieszczęśliwego wypadku
					</Styles.NNWContentTableNameCell>
					<Styles.NNWContentTableCell
						data-column-active={column1Active}
					>
						30 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column2Active}
					>
						40 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column3Active}
					>
						50 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column4Active}
					>
						100 000 zł
					</Styles.NNWContentTableCell>
				</Styles.NNWContentTableRow>
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableNameCell>
						trwały uszczerbek na zdrowiu - system świadczeń
						proporcjonalnych
					</Styles.NNWContentTableNameCell>
					<Styles.NNWContentTableCell
						data-column-active={column1Active}
					>
						30 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column2Active}
					>
						40 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column3Active}
					>
						50 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column4Active}
					>
						100 000 zł
					</Styles.NNWContentTableCell>
				</Styles.NNWContentTableRow>
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableNameCell>
						koszty nabycia wyrobów medycznych
					</Styles.NNWContentTableNameCell>
					<Styles.NNWContentTableCell
						data-column-active={column1Active}
					>
						6 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column2Active}
					>
						6 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column3Active}
					>
						6 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column4Active}
					>
						6 000 zł
					</Styles.NNWContentTableCell>
				</Styles.NNWContentTableRow>
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableNameCell>
						koszty przeszkolenia zawodowego osób z
						niepełnosprawnością
					</Styles.NNWContentTableNameCell>
					<Styles.NNWContentTableCell
						data-column-active={column1Active}
					>
						6 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column2Active}
					>
						6 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column3Active}
					>
						6 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column4Active}
					>
						6 000 zł
					</Styles.NNWContentTableCell>
				</Styles.NNWContentTableRow>
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableNameCell>
						koszty odbudowy stomatologicznej
					</Styles.NNWContentTableNameCell>
					<Styles.NNWContentTableCell
						data-column-active={column1Active}
					>
						5 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column2Active}
					>
						5 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column3Active}
					>
						5 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column4Active}
					>
						5 000 zł
					</Styles.NNWContentTableCell>
				</Styles.NNWContentTableRow>
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableNameCell>
						koszty jednorazowego świadczenia z tytułu trwałej utraty
						zdolności do pracy w dotychczasowym zawodzie
					</Styles.NNWContentTableNameCell>
					<Styles.NNWContentTableCell
						data-column-active={column1Active}
					>
						5 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column2Active}
					>
						5 000 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column3Active}
					>
						7 500 zł
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column4Active}
					>
						10 000 zł
					</Styles.NNWContentTableCell>
				</Styles.NNWContentTableRow>
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableNameCell
						style={{
							display: 'flex',
							flexFlow: 'row',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<span style={{ maxWidth: '40%' }}>
							assistance medyczny
						</span>
						<Styles.ExpandAssistanceButton
							expanded={assistanceExpanded}
							onClick={() =>
								setAssistanceExpanded((expanded) => !expanded)
							}
						>
							więcej
							<div>
								<SvgArrowDown2 />
							</div>
						</Styles.ExpandAssistanceButton>
					</Styles.NNWContentTableNameCell>
					<Styles.NNWContentTableCell
						data-column-active={column1Active}
					>
						TAK
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column2Active}
					>
						TAK
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column3Active}
					>
						TAK
					</Styles.NNWContentTableCell>
					<Styles.NNWContentTableCell
						data-column-active={column4Active}
					>
						TAK
					</Styles.NNWContentTableCell>
				</Styles.NNWContentTableRow>
				{assistanceExpanded && (
					<>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								wizyta lekarska
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								wizyta pielęgniarki
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								dostarczenie do miejsca pobytu leków
								przypisanych przez lekarza
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								100 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								100 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								100 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								100 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								transport z miejsca pobytu Ubezpieczonego do
								placówki medycznej
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								transport z placówki medycznej do miejsca pobytu
								Ubezpieczonego
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								pomoc domowa
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								pomoc psychologiczna
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								opieka nad dziećmi
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								500 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								organizacja opieki nad psami i kotami
								Ubezpieczonego znajdującymi się w jego domu
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								300 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								300 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								300 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								300 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								informacje o Służbie Zdrowia
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								bez limitu
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								bez limitu
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								bez limitu
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								bez limitu
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								powiadomienie o zaistniałym zdarzeniu rodziny
								oraz zakładu pracy
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								bez limitu
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								bez limitu
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								bez limitu
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								bez limitu
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								korepetycje
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								1 000 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								1 000 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								1 000 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								1 000 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
						<Styles.NNWContentTableRow>
							<Styles.NNWContentTableNameCell>
								assistance funeralne
							</Styles.NNWContentTableNameCell>
							<Styles.NNWContentTableCell
								data-column-active={column1Active}
							>
								4 000 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column2Active}
							>
								4 000 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column3Active}
							>
								4 000 zł
							</Styles.NNWContentTableCell>
							<Styles.NNWContentTableCell
								data-column-active={column4Active}
							>
								4 000 zł
							</Styles.NNWContentTableCell>
						</Styles.NNWContentTableRow>
					</>
				)}
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableNameCell>
						<strong>składka w zakresie całodobowym</strong>
						(wypadki w życiu prywatnym i zawodowym)
					</Styles.NNWContentTableNameCell>
					{risksFirstHalf.map((risk, idx) => {
						const riskState = props.selectedRisksIds.includes(
							risk.riskId
						);

						return (
							<Styles.NNWContentTableCell
								data-column-active={columnActiveArray[idx]}
								key={risk.riskId}
							>
								<Selectable
									label={`${risk.riskContribution} zł`}
									onClick={() =>
										FormManager.toggleSelectRisk(
											risk.riskId,
											'nnw'
										)
									}
									selected={riskState}
									style={
										Styles.nnwContentTableSelectableStyle
									}
								/>
							</Styles.NNWContentTableCell>
						);
					})}
				</Styles.NNWContentTableRow>
				<Styles.NNWContentTableRow>
					<Styles.NNWContentTableNameCell>
						<strong>składka w zakresie ograniczonym</strong>
						(pobyt w pracy oraz w drodze do i z pracy)
					</Styles.NNWContentTableNameCell>
					{risksSecondHalf.map((risk, idx) => {
						const riskState = props.selectedRisksIds.includes(
							risk.riskId
						);

						return (
							<Styles.NNWContentTableCell
								data-column-active={columnActiveArray[idx]}
								key={risk.riskId}
							>
								<Selectable
									label={`${risk.riskContribution} zł`}
									onClick={() =>
										FormManager.toggleSelectRisk(
											risk.riskId,
											'nnw'
										)
									}
									selected={riskState}
									style={
										Styles.nnwContentTableSelectableStyle
									}
								/>
							</Styles.NNWContentTableCell>
						);
					})}
				</Styles.NNWContentTableRow>
			</div>
			<div style={{ display: 'flex' }}>
				<Styles.NNWContentTableBlankCell className="bottom" />
				<Styles.NNWTableNoSelectContainer>
					<Selectable
						label={'NIE WYBIERAM'}
						onClick={() => FormManager.clearSelectedNNWRisks()}
						selected={
							!props.risks.some((el) =>
								props.selectedRisksIds.includes(el.riskId)
							)
						}
						style={{
							width: '100%',
							margin: '0 auto',
							height: '45px',
							fontSize: '16px',
						}}
					/>
				</Styles.NNWTableNoSelectContainer>
			</div>
		</Styles.NNWContentContainer>
	);
};

export const NNWBottomContent = (props: {
	risks: IRisk[];
	selectedRisksIds: number[];
}) => (
	<Styles.BottomContentContainer>
		<Styles.NNWBottomHeadingFont>
			klauzule dodatkowe
		</Styles.NNWBottomHeadingFont>
		<div>
			{props.risks.map((risk) => {
				const riskState = props.selectedRisksIds.includes(risk.riskId);

				return (
					<ConsentRow
						key={risk.riskId}
						checked={riskState}
						description={risk.riskName}
						onClick={() =>
							FormManager.toggleSelectRisk(risk.riskId, 'free')
						}
					/>
				);
			})}
		</div>
	</Styles.BottomContentContainer>
);

export const NNWExtendedContent = () => (
	<PaginatedDescription content={ExtendedContent.NNW} />
);
